const styleConstants = {
	colorPrimary: "#33C2FF",
	colorSecondary: "#7B69EC",
	gradientPrimary: ["33C2FF", "7B69EC"],
	borderRadius: 20,
	fonts: {
		heading: "Syne Variable, DM Sans Variable, sans-serif",
		subheading: "DM Sans Variable, sans-serif",
		body: "Outfit Variable, DM Sans Variable, sans-serif"
	}
}

export default styleConstants;